import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import usersApi, { updateUserData } from '../api/users';
import { toast } from 'react-toastify';
import { ICurrency } from './visitorInfoSlice';

interface IUser {
  _id: string;
  email: string;
  profilePic?: string;
  name: string;
  phoneNumber: string;
  preference?: {
    timezone: string;
    currency: ICurrency;
    lessonUpdates: boolean;
    accountUpdates: boolean;
  };
  address?: {
    area: string;
    town: string;
    state: string;
    pincode: string;
    country: string;
  };
  status?: string;
}

interface IInitalState {
  userData: IUser | null;
  error: string;
  loading: boolean;
}

const initalState: IInitalState = {
  userData: null,
  error: '',
  loading: false
};

export const getUserByEmail = createAsyncThunk(
  'getUserByEmail',
  async (email: string, { fulfillWithValue, rejectWithValue }) => {
    const data = await usersApi.getUserByEmail(email);
    // console.log(res.data);
    if (data) {
      return fulfillWithValue(data);
    } else {
      return rejectWithValue("");
    }
  }
);

export const updateUser = createAsyncThunk(
  'updateUser',
  async (data: updateUserData, { fulfillWithValue, rejectWithValue, getState }) => {
    // @ts-ignore
    const { userData } = getState().userSlice;
    try {
      const res = await usersApi.updateUser(userData._id, data);
      // console.log('Update user API =>', res);
      if (res) {
        toast.success('User Updated Successfully!');
        return fulfillWithValue(res);
      }
    } catch (err) {
      rejectWithValue(err);
      toast.error('Something went wrong');
    }
  }
);

const userSlice = createSlice({
  name: 'userSlice',
  initialState: initalState,
  reducers: {
    setUserProfile: (state, action) => {
      // console.log(action.payload);
      state.userData = action.payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(getUserByEmail.pending, (state /* , action */) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(getUserByEmail.fulfilled, (state, action) => {
      state.loading = false;
      state.error = '';
      //@ts-ignore
      state.userData = action.payload;
    });
    builder.addCase(getUserByEmail.rejected, (state /* , action */) => {
      state.loading = false;
      state.error = 'Something went wrong';
    });

    builder.addCase(updateUser.pending, (state /* , action */) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(updateUser.fulfilled, (state, action) => {
      // @ts-ignore
      state.userData = {
        ...state.userData,
        ...action.payload
      };
      state.error = '';
      state.loading = false;
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      // @ts-ignore
      state.error = action.payload;
      state.loading = false;
    });
  }
});

export const {
  /* addUser */
  setUserProfile
} = userSlice.actions;

export default userSlice.reducer;
